// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Wxe6N","title":"Images45_title__1xz2j","images":"Images45_images__1PUZn"};